// Types shared across StatsBarChart sub-components

// GameData re-exported from shared for existing consumers
export type { GameData } from '@parlay-picker/shared/statsChart';

export interface ChartDataPoint {
  value: number;
  date?: string;
  gameNumber: number;
  opponent?: string;
  min?: string;
  dnp: boolean;
  label: string;
  compactLabel: string;
  dateFormatted: string;
  // Team game context
  isHome?: boolean;
  teamScore?: number;
  opponentScore?: number;
  won?: boolean;
  /** False when period data is missing and full-game fallback is used */
  hasPeriodData: boolean;
}

export interface StatsBarChartProps {
  recentGames?: import('@parlay-picker/shared/statsChart').GameData[];
  h2hGames?: import('@parlay-picker/shared/statsChart').GameData[];
  propLine: number;
  /** The leg's own alternate X+ line, where a game equal to it is an over (isAlternateChartLine) */
  isAlternateLine: boolean;
  statKey: string;
  opponentAbbr?: string;
  overUnder?: string | null;
  odds?: string;
  opponentDefRank?: number;
  /** Sizes the DEF rank badge's tiers to the league's team count */
  leagueKey: import('@parlay-picker/shared/league').LeagueKey;
  /** Set to true for game props (hides player-specific features) */
  isGameProp?: boolean;
  /** Market key for period-specific charts (e.g., 'player_points_q1') */
  marketKey?: string;
}

export type ViewMode = 'L5' | 'L10' | 'L20' | 'H2H';

export const VIEW_MODES: readonly ViewMode[] = ['L5', 'L10', 'L20', 'H2H'];
